<template>
  <div>
    <el-dialog
      title="Aplicacion de Ingreso"
      :visible.sync="dialogIsVisible"
      @close="oncancel"
    >
      <el-form v-model="IncomeForm" ref="IncomeForm">
        <el-form-item label="Tipo de Ingreso">
          <el-select v-model="IncomeForm.IncomeType">
            <el-option
              v-for="item in IncomesTypes"
              :key="item.id"
              :label="item.description"
              :value="item.types"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Monto"> </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="oncancel">Cancelar</el-button>
        <el-button @click="dialogIsVisible = false">Aplicar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "IncomeDiscountToInsert",
  props: {
    IncomesDiscountType: {
      type: String,
      default: ""
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      IncomeForm: {
        IncomeType: ""
      },
      IncomesTypes: []
    };
  },
  created() {
    this.GetIncomesTypes();
  },
  computed: {
    dialogIsVisible() {
      return this.isVisible;
    }
  },
  methods: {
    oncancel() {
      this.$emit("Canceled");
    },
    GetIncomesTypes() {
      this.$http.get("/api/Payroll/GetIcomesTypes").then((response) => {
        //console.log("Response: ", response);
        this.IncomesTypes = response.data;
      });
    },
    GetDiscountsTypes() {
      this.$http.get("/api/Payroll/GetDiscountsTypes").then((response) => {
        //console.log("Response: ", response);
        this.IncomesTypes = response.data;
      });
    }
  },
  watch: {
    dialogIsVisible(val) {
      if (val === true) {
        this.GetIncomesTypes();
      }
    }
  }
};
</script>

<style></style>
